import { BaseService } from '@services/BaseService'
import axios from 'axios'
const resource = 'hr'

class HealthRecordService extends BaseService {
  constructor() {
    super(resource)
  }

  getRecords(data) {
    return axios.get(`${this.url}/${data}/?limit=9999&offset=0`)
  }
}

export const healthRecordService = new HealthRecordService()
